/* eslint-disable */
import React from 'react';
import moment from 'moment';

import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import CircularProgress from 'material-ui/CircularProgress';

import { submitForm } from '../modules/api';

class NewContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupFirstName: '',
            groupLastName: '',
            groupEmail: '',
            groupMobile: '',
            groupNumberOfGuests: '',
            groupBookingDate: null,
            groupRequests: '',
            minDate: new Date(),
            btnLoading: false,
            bookingError: false,
            bookingSuccess: false,
        };

        this.updateGroupInfo = this.updateGroupInfo.bind(this);
        this.validateBookingForm = this.validateBookingForm.bind(this);
        this.submitBooking = this.submitBooking.bind(this);
        this.finishBooking = this.finishBooking.bind(this);
    }

    updateGroupInfo(value, key) {
        this.setState({
            [key]: value,
        });
    }

    validateBookingForm() {
        if (!this.state.groupFirstName.trim() || !this.state.groupLastName.trim()) {
            return false;
        }
        if (!this.state.groupEmail) {
            return false;
        }
        if (!this.state.groupMobile) {
            return false;
        }
        if (!this.state.groupNumberOfGuests) {
            return false;
        }
        if (!this.state.groupBookingDate) {
            return false;
        }
        if (!this.state.groupRequests) {
            return false;
        }
        return true;
    }

    submitBooking() {
        if (this.validateBookingForm() && !this.state.btnLoading && !this.state.bookingSuccess) {
            this.setState({ btnLoading: true });
            submitForm({
                firstName: this.state.groupFirstName,
                lastName: this.state.groupLastName,
                email: this.state.groupEmail,
                phoneNumber: this.state.groupMobile,
                numberOfPeople: this.state.groupNumberOfGuests,
                date: moment(this.state.groupBookingDate).format('DD/MM/YYYY'),
                enquiry: this.state.groupRequests,
            }).then(() => {
                this.setState({
                    btnLoading: false,
                    bookingError: false,
                    bookingSuccess: true,
                });
            }).catch(err => {
                console.log(err);
                this.setState({
                    btnLoading: false,
                    bookingError: true,
                    bookingSuccess: false,
                });
            })
        }
    }

    finishBooking() {
        this.setState({
            groupFirstName: '',
            groupLastName: '',
            groupEmail: '',
            groupMobile: '',
            groupNumberOfGuests: 8,
            groupBookingDate: null,
            groupRequests: '',
            minDate: new Date(),
            btnLoading: false,
            bookingError: false,
            bookingSuccess: false,
        });
    }

    render() {
        return (
            <div>
                {
                    this.state.bookingError &&
                    <div style={{ color: 'red' }}>
                        Booking Error. Please try Refresh page or Contact <a href="tel:0731937392">(07) 3193 7392</a>
                    </div>
                }
                <div className="sidebar-container__info-form">
                    <div className="sidebar-container__info-form-row">
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupFirstName"
                                fullWidth
                                floatingLabelText="First Name*"
                                value={this.state.groupFirstName}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupFirstName')}
                            />
                        </div>
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupLastName"
                                fullWidth
                                floatingLabelText="Last Name*"
                                value={this.state.groupLastName}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupLastName')}
                            />
                        </div>
                    </div>
                    <div className="sidebar-container__info-form-row">
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupMobile"
                                fullWidth
                                floatingLabelText="Phone Number*"
                                value={this.state.groupMobile}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupMobile')}
                            />
                        </div>
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupEmail"
                                type="email"
                                fullWidth
                                floatingLabelText="Email*"
                                value={this.state.groupEmail}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupEmail')}
                            />
                        </div>
                    </div>
                    <div className="sidebar-container__info-form-row">
                        <div className="sidebar-container__info-form-col">
                            <DatePicker
                                id="groupBookingDate"
                                fullWidth
                                floatingLabelText="Date*"
                                autoOk
                                formatDate={new global.Intl.DateTimeFormat('en-AU').format}
                                // minDate={this.state.minDate}
                                value={this.state.groupBookingDate}
                                onChange={(evt, date) => this.setState({ groupBookingDate: date })}
                            />
                        </div>
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupNumberOfGuests"
                                fullWidth
                                type="number"
                                floatingLabelText="Number of Guests*"
                                value={this.state.groupNumberOfGuests}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupNumberOfGuests')}
                            />
                        </div>
                    </div>
                    <div className="sidebar-container__info-form-row">
                        <div className="sidebar-container__info-form-col">
                            <TextField
                                id="groupRequests"
                                fullWidth
                                multiLine
                                floatingLabelText="Enquiry*"
                                value={this.state.groupRequests}
                                onChange={evt => this.updateGroupInfo(evt.target.value, 'groupRequests')}
                            />
                        </div>
                    </div>
                    <a
                        href="#send"
                        className={`sidebar-container__next-btn${
                            (this.validateBookingForm() && !this.state.bookingSuccess) ? '' : ' disabled'}`}
                        onClick={(evt) => {
                            evt.preventDefault();
                            this.submitBooking();
                        }}
                        style={{ maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' }}
                    >
                        {
                            this.state.btnLoading ?
                                <div style={{ display: 'flex' }}>
                                    <CircularProgress size={18} thickness={2} />
                                </div>:
                                this.state.bookingSuccess ? 'Submitted' : 'Submit Enquiry'
                        }
                    </a>
                </div>
            </div>
        );
    }
}

export default NewContactForm;


// WEBPACK FOOTER //
// ./src/Theme/NewContactForm.jsx